import { Component, Inject, OnInit } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LookupItemStruct } from '../../../../../shared/services/structs/pessoa/lookup-item.struct';
import { TagListItem } from '../../../../../shared/services/structs/produto/tag-list-item.struct';
import { ProdutoService } from '../../../../../shared/services/apis/produto/produto.service';
import { AlertService, AlertType } from '../../../../../shared/services/alert.service';
import { AlterarTagsProdutoRequest } from '../../../../../shared/services/requests/produto/alterar-tags-produto.request';

export interface AlterarTagsDialogData {
  listaProdutoIds: number[];
  listaTag: TagListItem[];
}

@Component({
  selector: 'app-prod-alterar-tags-dialog',
  standalone: true,
  imports: [
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './alterar-tags-dialog.component.html',
  styleUrls: ['./alterar-tags-dialog.component.css'],
})
export class AlterarTagsDialogComponent implements OnInit {
  public modo: string = 'incluir';
  public searchText: string = '';
  public tagsSelecionadas: Set<number> = new Set();
  public tagsFiltradas: TagListItem[] = [];
  public isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AlterarTagsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AlterarTagsDialogData,
    private produtoService: ProdutoService,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.tagsFiltradas = [...this.data.listaTag];
  }

  public filtrarTags(): void {
    const termo = this.searchText.toLowerCase().trim();
    if (!termo) {
      this.tagsFiltradas = [...this.data.listaTag];
    } else {
      this.tagsFiltradas = this.data.listaTag.filter(tag => tag.nome.toLowerCase().includes(termo));
    }
  }

  public toggleTag(tagId: number): void {
    if (this.tagsSelecionadas.has(tagId)) {
      this.tagsSelecionadas.delete(tagId);
    } else {
      this.tagsSelecionadas.add(tagId);
    }
  }

  public isTagSelecionada(tagId: number): boolean {
    return this.tagsSelecionadas.has(tagId);
  }

  public get contadorText(): string {
    const count = this.tagsSelecionadas.size;
    if (count === 0) return '';
    return count === 1 ? '1 tag selecionada' : `${count} tags selecionadas`;
  }

  public get helpText(): string {
    if (this.modo === 'incluir') {
      return 'As tags selecionadas serão adicionadas aos produtos, mantendo as existentes.';
    }
    return 'As tags selecionadas serão removidas dos produtos, mantendo as demais existentes.';
  }

  public get podeAplicar(): boolean {
    return this.tagsSelecionadas.size > 0 && !this.isLoading;
  }

  public salvar(): void {
    if (!this.podeAplicar) return;

    this.isLoading = true;

    const request = new AlterarTagsProdutoRequest();
    request.idsProduto = this.data.listaProdutoIds;
    request.idsTag = Array.from(this.tagsSelecionadas);
    request.isIncluir = this.modo === 'incluir';

    this.produtoService.alterarTagsMassivo(request).subscribe({
      next: res => {
        this.isLoading = false;
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }
        const mensagem =
          this.modo === 'incluir' ? 'Tags incluídas com sucesso!' : 'Tags removidas com sucesso!';
        this.alertService.show('Sucesso', mensagem, AlertType.success);
        this.dialogRef.close({ success: true });
      },
      error: () => {
        this.isLoading = false;
        this.alertService.show('Erro', 'Falha ao atualizar as tags.', AlertType.error);
      },
    });
  }

  public fechar(): void {
    this.dialogRef.close();
  }

  public onModoChange(): void {
    this.tagsSelecionadas.clear();
  }
}
